export default __webpack_public_path__ + "static/media/mask-psy.a9e4f166.jpg";